
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import "../src/assets/css/demo.css";
import "../src/assets/css/paper-dashboard.css";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import DefaultLayout from "./layout/DefaultLayout";
import './App.css';
import './assets/css/inspectaly-brand.css';
import { AppContext } from './AppContext'


import Dashboard from './views/dashboard/Dashboard';
import Login from './views/login/Login';
import { useState } from 'react';
import Register from './views/register/Register';
import ForgotPassword from './views/forgotPassword/ForgotPassword';
import ResetPassword from './views/resetPassword/ResetPassword';
import ListPackages from './views/packages/ListPackages';
import AccountDelete from "./views/accountDeletion/AccountDelete";

function App() {
  const [userData, setUserData] = useState(null);
  const updateUserData = (data) => {
    setUserData(data);
  };
//   console.log(userData,'userData')
  
  return (
    <div className="App">
      <AppContext.Provider value={{
        userData, 
        updateUserData
		}}>
      <BrowserRouter>
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/packages" element={<ListPackages />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/register" element={<Register />} />
      <Route path="/reset-password/:token" element={<ResetPassword />} />
      <Route path="/request-account-deletion" element={<AccountDelete />} />
      <Route path="/*" element={<DefaultLayout />} />
      {/* <Route path="/" element={<Navigate to="/dashboard" replace />} /> */}
    </Routes>
  </BrowserRouter>
  </AppContext.Provider>
    </div>
  );
}

export default App;
